import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { NAV_LINKS } from './nav';

const FOOTER_LINKS = [
  ...NAV_LINKS,
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/delete-account', label: 'Delete account' },
  { to: '/support', label: 'Support' },
];

// Shared footer for the marketing pages.
function SiteFooter() {
  return (
    <footer className="py-12 text-center border-t border-[var(--color-ink-subtle)]/10 bg-[var(--color-paper-bg)]">
      <div className="flex items-center justify-center gap-2 mb-4 opacity-50">
        <Calendar className="w-5 h-5" />
        <span className="font-serif font-bold">Steadily.me</span>
      </div>
      <p className="text-[var(--color-ink-subtle)] text-sm font-serif">
        &copy; 2026 Reality Moss LLC. Built for consistency, designed for life.
      </p>
      <nav className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-serif" aria-label="Footer">
        {FOOTER_LINKS.map((link, i) => (
          <span key={link.to} className="inline-flex items-center gap-5">
            {i > 0 && <span className="text-[var(--color-ink-subtle)]" aria-hidden="true">·</span>}
            <Link
              to={link.to}
              className="text-[var(--color-ink-subtle)] hover:text-[var(--color-ink-main)] transition-colors"
            >
              {link.label}
            </Link>
          </span>
        ))}
      </nav>
    </footer>
  );
}

export default SiteFooter;
